import React, {FunctionComponent} from "react";
import { assetUrl } from "../../utils/misc";

import './StoreApps.css';

interface IBuildingStoreApps{
    googlePlay:string,
    iTunes:string
}

const StoreApps:FunctionComponent<IBuildingStoreApps> = ({googlePlay,iTunes})=>{
    return <div className="store-apps">
        {
            googlePlay &&
                <a href={googlePlay}>
                    <img
                        className="google-play-badge"
                        src={assetUrl("/images/vendor/google-play-badge.png")}
                        alt="Google Play"
                    />
                </a>
        }
        {
            iTunes &&
            <a href={iTunes}>
                <img
                    className="app-store-badge"
                    src={assetUrl("/images/vendor/app-store-badge.svg")}
                    alt="App store"
                />
            </a>
        }
    </div>
}

export default StoreApps;
